import FormattedMessage from 'I18n/components/FormattedMessage';
import { SubmissionApiFailureResponse } from 'ui-deal-management-components-lib/types/ResponseStatus';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
import { fetchForecastAmountPipelineConfig, saveForecastAmountPipelineConfig, fetchPortalWideCadence as fetchPortalWideCadenceRequest, fetchForecastTypes as fetchForecastTypesRequest, fetchRepDealColumns as fetchRepDealColumnsRequest, updateRepDealColumns as updateRepDealColumnsRequest, deleteRepDealColumns as deleteRepDealColumnsRequest } from '../api/forecastApi';
import { fetchPipelines as fetchPipelinesRequest } from '../api/pipelinesApi';
import { FILTERS } from '../constants/FiltersConstants';
import { ForecastAmountSettingOptions } from '../constants/PortalConfigConstants';
import { FORECAST_CATEGORY } from '../constants/DealGroupingType';
import { deriveCurrentTimePeriodForCadence, getOffsetTimePeriod, getTimePeriodOption } from '../utils/dateUtils';
import { getHasForecastingEditScope } from '../selectors/authSelectors';
import { getSelectedTeamId } from '../selectors/overviewSelectors';
import { getDealGroupingTypeFilter, getTimePeriodFilter, getFilters, getIsMultipipeline } from '../selectors/filtersSelectors';
import { getIsAllPipelines, getSelectedForecastTypeIdOrGatedDefault } from '../selectors/forecastSelectors';
import { getCurrentDatePortalTz } from '../selectors/dateSelectors';
import { FETCH_PORTAL_CONFIG_STARTED, FETCH_PORTAL_CONFIG_SUCCEEDED, FETCH_PORTAL_WIDE_CADENCE_SUCCEEDED, FORECAST_SUBMISSION_SUCCEEDED, FORECAST_SUBMISSION_FAILED, FORECAST_SUBMISSION_INVALID_DEAL_IDS, FETCH_PIPELINES_SUCCEEDED, UPDATE_FORECAST_DISPLAY_VALUE, FETCH_FORECAST_TYPES_STARTED, FETCH_FORECAST_TYPES_SUCCEEDED, FETCH_FORECAST_TYPES_FAILED, FETCH_REP_DEAL_COLUMNS_STARTED, FETCH_REP_DEAL_COLUMNS_SUCCEEDED, FETCH_REP_DEAL_COLUMNS_FAILED, UPDATE_REP_DEAL_COLUMNS } from './ActionTypes';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const forecastSubmissionSuccessAlertAction = {
  type: FORECAST_SUBMISSION_SUCCEEDED,
  meta: {
    notification: {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "notifications.forecastSubmission.success"
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "notifications.forecastSubmission.message"
      }),
      type: 'success',
      ['data-test-id']: 'alert'
    }
  }
};
export const forecastSubmissionSuccessWithRefreshAlertAction = {
  type: FORECAST_SUBMISSION_SUCCEEDED,
  meta: {
    notification: {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "notifications.forecastSubmission.success"
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "notifications.forecastSubmission.refreshMessage"
      }),
      type: 'success',
      ['data-test-id']: 'alert'
    }
  }
};
export const forecastSubmissionInvalidDealIdsAlertAction = {
  type: FORECAST_SUBMISSION_INVALID_DEAL_IDS,
  meta: {
    notification: {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "notifications.forecastSubmission.failure.invalidDealPermissions.titleText"
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "notifications.forecastSubmission.failure.invalidDealPermissions.message"
      }),
      type: 'danger'
    }
  }
};
export const forecastSubmissionFailureAlertAction = {
  type: FORECAST_SUBMISSION_FAILED,
  meta: {
    notification: {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "notifications.forecastSubmission.failure.generic.titleText"
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "notifications.forecastSubmission.failure.generic.message"
      }),
      type: 'danger'
    }
  }
};
export function updateForecastDisplayValue({
  amount,
  currentTeamId,
  id,
  isMultipipeline,
  isUser,
  prevAmount,
  isAllPipelinesSubmission,
  isFilteredToAllPipelines
}) {
  return {
    type: UPDATE_FORECAST_DISPLAY_VALUE,
    payload: {
      amount,
      currentTeamId,
      id,
      isMultipipeline,
      isUser,
      prevAmount,
      isAllPipelinesSubmission,
      isFilteredToAllPipelines
    }
  };
}
export function fetchPipelines() {
  return dispatch => {
    return fetchPipelinesRequest().then(data => {
      dispatch({
        type: FETCH_PIPELINES_SUCCEEDED,
        payload: data
      });
    });
  };
}
export function fetchPortalWideCadence() {
  return dispatch => {
    return fetchPortalWideCadenceRequest().then(data => dispatch({
      type: FETCH_PORTAL_WIDE_CADENCE_SUCCEEDED,
      payload: data
    })).catch(error => logRavenException(error, 'Fetch Portal Wide Cadence'));
  };
}
export function submitForecastFailed(error) {
  return dispatch => {
    logRavenException(error, FORECAST_SUBMISSION_FAILED);
    switch (error) {
      case SubmissionApiFailureResponse.DEAL_ID_ERROR:
        dispatch(forecastSubmissionInvalidDealIdsAlertAction);
        return;
      default:
        dispatch(forecastSubmissionFailureAlertAction);
    }
  };
}
export function updateForecastDisplayFromEmbeddedSubmission({
  amount,
  cadence,
  fiscalOffset,
  id,
  isUser,
  prevAmount,
  submittedPipelineId,
  timePeriodValue,
  isAllPipelinesSubmission
}) {
  return (dispatch, getState) => {
    const state = getState();
    const timePeriod = getTimePeriodFilter(state);
    const isMultipipeline = getIsMultipipeline(state);
    const currentTeamId = getSelectedTeamId(state);
    const tab = getDealGroupingTypeFilter(state);
    const isAllPipelines = getIsAllPipelines(state);
    const currentDate = I18n.moment.portalTz(getCurrentDatePortalTz(state));
    const currentTimePeriod = deriveCurrentTimePeriodForCadence({
      cadence,
      currentMonth: currentDate.month() + 1,
      fiscalOffset
    });
    const offsetTimePeriod = getOffsetTimePeriod({
      cadence,
      currentTimePeriod,
      timePeriod
    });

    // TODO #2518: this does not account for a submission created in a future range of multiple months / quarters
    const submissionIsForCurrentPeriod = cadence === getTimePeriodOption(timePeriod) && offsetTimePeriod === timePeriodValue;
    const submissionIsForCurrentPipeline = tab === FORECAST_CATEGORY ? getFilters(state).get(FILTERS.PIPELINE).includes(submittedPipelineId) : getFilters(state).get(FILTERS.PIPELINE).get(0) === submittedPipelineId;

    // This checks that we're filtered to all pipelines and that the actual submission was made for all pipelines
    const submissionIsForAllPipelines = isAllPipelines && isAllPipelinesSubmission;
    const submissionIsForCurrentOrAllPipelines = submissionIsForAllPipelines || submissionIsForCurrentPipeline;
    if (!submissionIsForCurrentPeriod || !submissionIsForCurrentOrAllPipelines) {
      dispatch(forecastSubmissionSuccessWithRefreshAlertAction);
      return;
    }
    dispatch(updateForecastDisplayValue({
      isUser,
      id,
      amount,
      isMultipipeline,
      currentTeamId,
      prevAmount,
      isAllPipelinesSubmission,
      isFilteredToAllPipelines: isAllPipelines
    }));

    // No need to refresh the page if alert table is not visible
    dispatch(forecastSubmissionSuccessAlertAction);
  };
}
export function fetchPortalConfig() {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_PORTAL_CONFIG_STARTED
    });
    return fetchForecastAmountPipelineConfig().then(data => {
      dispatch({
        type: FETCH_PORTAL_CONFIG_SUCCEEDED,
        payload: data.forecastDealAmountConfiguration
      });
      return data.forecastDealAmountConfiguration;
    }).catch(error => {
      if (error.status === 404) {
        // non super admins do not have permissions to update the portal config
        // default to weighted amount until otherwise set by the super admin
        return getHasForecastingEditScope(getState()) ? saveForecastAmountPipelineConfig(ForecastAmountSettingOptions.WEIGHTED_AMOUNT).then(() => ForecastAmountSettingOptions.WEIGHTED_AMOUNT) : Promise.resolve(ForecastAmountSettingOptions.WEIGHTED_AMOUNT);
      }
      logRavenException(error, 'Fetch Forecast Amount Pipeline Config');
      return undefined;
    });
  };
}
export function fetchForecastTypes() {
  return dispatch => {
    dispatch({
      type: FETCH_FORECAST_TYPES_STARTED
    });
    return fetchForecastTypesRequest().then(data => dispatch({
      type: FETCH_FORECAST_TYPES_SUCCEEDED,
      payload: data.forecastTypes
    })).catch(error => {
      dispatch({
        type: FETCH_FORECAST_TYPES_FAILED
      });
      return logRavenException(error, 'Fetch Forecast Types');
    });
  };
}
export function fetchRepDealColumns() {
  return dispatch => {
    dispatch({
      type: FETCH_REP_DEAL_COLUMNS_STARTED
    });
    return fetchRepDealColumnsRequest().then(data => dispatch({
      type: FETCH_REP_DEAL_COLUMNS_SUCCEEDED,
      payload: data
    })).catch(error => {
      dispatch({
        type: FETCH_REP_DEAL_COLUMNS_FAILED
      });
      return logRavenException(error, 'Fetch Rep Deal Columns');
    });
  };
}
export function updateRepDealColumns(dealColumns) {
  return (dispatch, getState) => {
    const state = getState();
    const forecastTypeId = getSelectedForecastTypeIdOrGatedDefault(state);
    updateRepDealColumnsRequest(dealColumns, forecastTypeId).then(() => {
      dispatch({
        type: UPDATE_REP_DEAL_COLUMNS,
        payload: {
          dealColumns,
          forecastTypeId
        }
      });
    }).catch(error => {
      logRavenException(error, 'Update Rep Deal Columns', {
        dealColumns,
        forecastTypeId
      });
    });
  };
}
export function deleteRepDealColumns(defaultDealColumns) {
  return (dispatch, getState) => {
    const state = getState();
    const forecastTypeId = getSelectedForecastTypeIdOrGatedDefault(state);
    deleteRepDealColumnsRequest(forecastTypeId).then(() => {
      dispatch({
        type: UPDATE_REP_DEAL_COLUMNS,
        payload: {
          dealColumns: defaultDealColumns,
          forecastTypeId
        }
      });
    }).catch(error => {
      logRavenException(error, 'Delete Rep Deal Columns to use default instead', {
        defaultDealColumns,
        forecastTypeId
      });
    });
  };
}